export function getParam( str, key ) {
    let regexS = "[\\?&]" + key + "=([^&#]*)";
    let regex = new RegExp(regexS);
    let results = regex.exec(str);
    if (results == null) {
        return "";
    } else {
        return results[1];
    }
}

/**
 * reformats the release url to a jw player supported release url
 */
 export function reformatReleaseUrl( releaseUrl ) {
   //constructing new release url format if url contains old format
   if(releaseUrl && releaseUrl.indexOf('mbr=true') > -1 ) {
        let releaseId = releaseUrl.match(/BKQ29B\/(.*?)\?/)[1];
        return releaseUrl =  "https://link.theplatform.com/s/BKQ29B/" + releaseId + "?formats=m3u";
    }
    return releaseUrl;
 }

/**
 * get duration in seconds. hours may need to be supported later on 
 * @param string duration - expects something like "0:50"
 * @return int - video duration
 */
export function convertTimeToSeconds( time ) {
    
    return time ? time
        .split(':')
        .reverse()
        .map((i, idx) => (+i) * Math.pow(60, idx))
        .reduce((acc, curr) => acc + curr, 0) : 0;
}

export function generateUUID() {
    const cryp = window.crypto || window.msCrypto;
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ cryp.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      )
}

export function getUUID() {
    const wis = window.wisRegistration;
    if( wis && typeof wis.getDeviceID === 'function' && wis.getDeviceID() ){
        return wis.getDeviceID();
    } 
    // access local storage
    const storage = window.localStorage;
    let userJWT = storage.getItem('_WIS_anon_userJWT'); 
    if(userJWT) {
        userJWT = JSON.parse(userJWT);
        return userJWT.deviceId;
    }
    const userKey = "fscom_user";
    let userData = storage.getItem(userKey); 
    if(userData) {
        userData = JSON.parse(userData);
        return userData.deviceId;
    }

    // generate a unique
    const deviceId = generateUUID();
    userData = { deviceId: deviceId };
    userData = JSON.stringify(userData);
    storage.setItem(userKey, userData);
    return deviceId;
}